// extracted by mini-css-extract-plugin
export default {"container":"SubformCommentSection_container__TG6F2","sectionDivider":"SubformCommentSection_sectionDivider__T8nQ5","commentLabel":"SubformCommentSection_commentLabel__ZYMqL"};